/* eslint-disable no-restricted-properties */
/* eslint-disable max-lines-per-function */
'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import * as React from 'react';
import { CopyToClipboardAlert } from '@/components/alerts/alerts';
import { renderShareActionIcon } from '@/utils/share-page-buttons';
interface SharePageProps {
  readonly text: string;
}
function SharePage(t0) {
  const $ = _c(35);
  const {
    text
  } = t0;
  const [copyToClipboardAlertIsVisible, setCopyToClipboardAlertIsVisible] = useState(false);
  const [shareUrl, setShareUrl] = useState("");
  const pathname = usePathname();
  let t1;
  let t2;
  if ($[0] !== pathname) {
    t1 = () => {
      const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || "https://thefuturefound.com";
      setShareUrl(`${baseUrl}${pathname}`);
    };
    t2 = [pathname];
    $[0] = pathname;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let getGTMParamValue;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] !== copyToClipboardAlertIsVisible || $[4] !== shareUrl || $[5] !== text) {
    const shareOptions = [{
      name: "Facebook",
      title: "Share on Facebook"
    }, {
      name: "Twitter",
      title: "Share on Twitter"
    }, {
      name: "LinkedIn",
      title: "Share on LinkedIn"
    }];
    let t7;
    if ($[11] !== shareUrl) {
      t7 = t8 => {
        const {
          gtmEvent,
          gtmParamName
        } = t8;
        const events = {
          share: {
            content_type: "Webpage",
            item_id: shareUrl
          }
        };
        return events[gtmEvent as keyof typeof events][gtmParamName as keyof typeof events.share];
      };
      $[11] = shareUrl;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    getGTMParamValue = t7;
    const getShareUrl = t8 => {
      const {
        platformName,
        textString
      } = t8;
      const shareStringEncode = _temp;
      const shareUrlMap = {
        default: _temp2,
        email: () => {
          const subject = encodeURIComponent(textString);
          const body = encodeURIComponent(`${shareUrl}?utm_source=share&utm_campaign=website&utm_medium=email`);
          return `mailto:?subject=${subject}&body=${body}`;
        },
        facebook: () => `https://www.facebook.com/sharer/sharer.php?u=${shareStringEncode(`${shareUrl}`)}&quote=${shareStringEncode(textString)}`,
        linkedin: () => `https://www.linkedin.com/sharing/share-offsite/?url=${shareStringEncode(`${shareUrl}`)}&title=${shareStringEncode(textString)}`,
        sms: () => {
          const message = `${textString} ${shareUrl}?utm_source=share&utm_campaign=website&utm_medium=sms`;
          return `sms:?body=${encodeURIComponent(message)}`;
        },
        twitter: () => `https://twitter.com/intent/tweet?text=${shareStringEncode(textString)}&url=${shareStringEncode(`${shareUrl}&via=Info4PI`)}`,
        whatsapp: () => {
          const message_0 = encodeURIComponent(`${textString} ${shareUrl}?utm_source=share&utm_campaign=website&utm_medium=whatsapp`);
          return `whatsapp://send?text=${message_0}`;
        }
      };
      const shareFunction = shareUrlMap[platformName.toLowerCase()] || shareUrlMap.default;
      return shareFunction ? shareFunction() : "#";
    };
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = () => setCopyToClipboardAlertIsVisible(false);
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    if ($[14] !== copyToClipboardAlertIsVisible) {
      t6 = <CopyToClipboardAlert dismiss={t9} isVisible={copyToClipboardAlertIsVisible} message="Link copied to clipboard." />;
      $[14] = copyToClipboardAlertIsVisible;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t3 = "social share-buttons share-page";
    t4 = "Share";
    t5 = shareOptions.map(option => <li key={option.name}><a className="gtm-share share-button" data-gtm-param-method={option.name} rel="noreferrer" target="_blank" title={option.title} data-gtm-param-content-type={getGTMParamValue({
        gtmEvent: "share",
        gtmParamName: "content_type"
      })} data-gtm-param-item-id={getGTMParamValue({
        gtmEvent: "share",
        gtmParamName: "item_id"
      })} href={getShareUrl({
        platformName: option.name,
        textString: text
      })}>{renderShareActionIcon({
          iconName: option.name
        })}</a></li>);
    $[3] = copyToClipboardAlertIsVisible;
    $[4] = shareUrl;
    $[5] = text;
    $[6] = getGTMParamValue;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    getGTMParamValue = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[16] !== getGTMParamValue) {
    t7 = getGTMParamValue({
      gtmEvent: "share",
      gtmParamName: "content_type"
    });
    $[16] = getGTMParamValue;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== getGTMParamValue) {
    t8 = getGTMParamValue({
      gtmEvent: "share",
      gtmParamName: "item_id"
    });
    $[18] = getGTMParamValue;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== shareUrl) {
    t9 = () => {
      const clipBoardAPIisAvailable = !!(navigator.clipboard && navigator.clipboard.writeText);
      if (clipBoardAPIisAvailable) {
        navigator.clipboard.writeText(shareUrl).then(() => {
          setCopyToClipboardAlertIsVisible(true);
          setTimeout(() => {
            setCopyToClipboardAlertIsVisible(false);
          }, 5000);
        }).catch(_temp3);
      } else {
        ;
        try {
          const textArea = document.createElement("textarea");
          textArea.value = shareUrl;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
          setCopyToClipboardAlertIsVisible(true);
          setTimeout(() => {
            setCopyToClipboardAlertIsVisible(false);
          }, 5000);
        } catch (t10) {
          const error_0 = t10;
          console.error("Error copying to clipboard:", error_0);
        }
      }
    };
    $[20] = shareUrl;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = renderShareActionIcon({
      iconName: "copy"
    });
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t11 = <li><button className="gtm-share share-button" data-gtm-param-method="Copy to Clipboard" title="Copy Link" type="button" data-gtm-param-content-type={t7} data-gtm-param-item-id={t8} onClick={t9}>{t10}</button></li>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5) {
    t12 = <ul className={t3} data-label={t4}>{t5}{t11}</ul>;
    $[27] = t11;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t12 || $[33] !== t6) {
    t13 = <>{t6}{t12}</>;
    $[32] = t12;
    $[33] = t6;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
}
function _temp3(error) {
  console.error("Error copying to clipboard:", error);
}
function _temp2() {
  return "#";
}
function _temp(str) {
  return encodeURIComponent(str);
}
export default SharePage;